import { Card } from "react-bootstrap";
import ReactPlayer from "react-player";

export default function GetAdvertisementElement(data: any) {
  return (
    <div>
      {data.type === 1 || data.type === 2 ? (
        <Card className="theme-medium-light-gray inherit-height inherit-width">
          <Card.Img
            src={data?.source}
            className="inherit-height inherit-width"
            alt="Adv image"
            style={{ padding: "1%", borderRadius: "inherit" }}
          />
          {/* <Card.ImgOverlay >
                        <Card.Title style={{ marginTop: 0 }}>Adv</Card.Title>
                    </Card.ImgOverlay> */}
        </Card>
      ) : data.type === 3 ? (
        <Card className="theme-medium-light-gray inherit-height inherit-width">
          <ReactPlayer
            url={data?.source}
            style={{ padding: "1%", borderRadius: "inherit" }}
            width={"100%"}
            height={"100%"}
            loop={true}
            playing={true}
            muted={true}
            controls={false}
            youtubeConfig={{
              playerVars: {
                rel: 0,
                showinfo: 0,
                ecver: 2,
                iv_load_policy: 3,
                mute: 1,
              },
            }}
          />
          <div
            style={{
              position: "absolute",
              zIndex: "9999",
              width: "inherit",
              height: "inherit",
            }}
          ></div>
        </Card>
      ) : null}
    </div>
  );
}
